(() => {
  'use strict';
  if (window.__lmlConversionEvents) return;
  window.__lmlConversionEvents = true;
  const key = 'lml.enquiry.pending.v1';
  const maxAge = 30 * 60 * 1000;
  const validKinds = /^(appointment|callback|piece|shipping|bespoke|trade|contact_[a-zA-Z0-9_-]+|atelier_visit)$/;

  function permissions() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    try {
      return {
        analytics: !!privacy && privacy.analyticsProcessingAllowed() === true,
        ads: !!privacy && privacy.marketingAllowed() === true
      };
    } catch (_) {
      return { analytics: false, ads: false };
    }
  }

  function clearPending() {
    try { window.sessionStorage.removeItem(key); } catch (_) {}
  }

  function readPending() {
    try { return JSON.parse(window.sessionStorage.getItem(key)); } catch (_) { return null; }
  }

  function newId() {
    if (!window.crypto || !window.crypto.randomUUID) return null;
    return window.crypto.randomUUID();
  }

  function emit(event, detail, allowed) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event,
      lml_analytics_allowed: allowed.analytics,
      lml_ads_allowed: allowed.ads
    }, detail));
  }

  function confirmSubmission() {
    const pending = readPending();
    if (!pending) return;
    if (!validKinds.test(pending.kind || '') ||
        !/^[a-f0-9-]{36}$/.test(pending.id || '') ||
        typeof pending.at !== 'number' || Date.now() - pending.at > maxAge ||
        Date.now() < pending.at) {
      clearPending();
      return;
    }
    if (pending.path !== window.location.pathname) return;
    const markers = Array.from(document.querySelectorAll('[data-lml-enquiry-kind]'));
    const matching = markers.filter(marker => marker.dataset.lmlEnquiryKind === pending.kind);
    if (matching.some(marker => marker.dataset.lmlEnquiryState === 'error')) {
      clearPending();
      return;
    }
    if (!matching.some(marker => marker.dataset.lmlEnquiryState === 'success')) return;
    const allowed = permissions();
    if (!allowed.analytics && !allowed.ads) return;
    try {
      window.sessionStorage.removeItem(key);
      if (window.sessionStorage.getItem(key)) return;
    } catch (_) { return; }
    emit('lml_enquiry_success', {
      enquiry_type: pending.kind,
      submission_id: pending.id
    }, allowed);
  }

  window.addEventListener('submit', event => {
    const form = event.target;
    if (!form || !form.querySelector) return;
    const marker = form.querySelector('[data-lml-enquiry-kind]');
    if (!marker || !validKinds.test(marker.dataset.lmlEnquiryKind || '')) return;
    queueMicrotask(() => {
      if (event.defaultPrevented) return;
      const allowed = permissions();
      if (!allowed.analytics && !allowed.ads) { clearPending(); return; }
      const id = newId();
      if (!id) return;
      try {
        window.sessionStorage.setItem(key, JSON.stringify({
          kind: marker.dataset.lmlEnquiryKind,
          id,
          path: window.location.pathname,
          at: Date.now()
        }));
      } catch (_) {}
    });
  });

  document.addEventListener('click', event => {
    const link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    let url;
    try { url = new URL(link.href, window.location.origin); } catch (_) { return; }
    let method;
    if (url.protocol === 'tel:') method = 'phone';
    else if (url.protocol === 'mailto:') method = 'email';
    else if (url.protocol === 'https:' && ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) method = 'whatsapp';
    if (!method) return;
    const allowed = permissions();
    if (!allowed.analytics && !allowed.ads) return;
    const id = newId();
    if (!id) return;
    emit('lml_contact_click', { contact_method: method, interaction_id: id }, allowed);
  });

  function ready() {
    confirmSubmission();
    if (window.Shopify && window.Shopify.loadFeatures && !window.Shopify.customerPrivacy) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) confirmSubmission();
      });
    }
  }
  document.addEventListener('visitorConsentCollected', () => {
    const allowed = permissions();
    if (!allowed.analytics && !allowed.ads) clearPending();
    else confirmSubmission();
  });
  window.addEventListener('pageshow', confirmSubmission);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();
